"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewGatewayGod extends new_item_1.default {
    constructor(newGatewayGod) {
        super();
        this.owner = newGatewayGod.owner;
        this.updateState = newGatewayGod.updateState;
        this.targetVersion = newGatewayGod.targetVersion;
        if (!newGatewayGod.name) {
            throw Error("name required");
        }
        this.name = newGatewayGod.name;
        this.scanning = newGatewayGod.scanning;
        this.status = newGatewayGod.status;
        this.physicalGatewayId = newGatewayGod.physicalGatewayId;
        this.ethernetMac = newGatewayGod.ethernetMac;
        this.wlanMac = newGatewayGod.wlanMac;
        this.lastContacted = newGatewayGod.lastContacted;
        this.siteId = newGatewayGod.siteId;
        this.siteName = newGatewayGod.siteName;
        this.connectionType = newGatewayGod.connectionType;
        this.powerSource = newGatewayGod.powerSource;
        this.totalDevices = newGatewayGod.totalDevices;
        this.connectedDevices = newGatewayGod.connectedDevices;
        this.charge = newGatewayGod.charge;
        this.wifiNetwork = newGatewayGod.wifiNetwork;
        this.activeConnection = newGatewayGod.activeConnection;
        this._permission = newGatewayGod._permission;
        this.wifiStrength = newGatewayGod.wifiStrength;
        this.mobileStrength = newGatewayGod.mobileStrength;
        this.imsi = newGatewayGod.imsi;
        this.ipAddress = newGatewayGod.ipAddress;
        this.serialNumber = newGatewayGod.serialNumber;
        this.modelNumber = newGatewayGod.modelNumber;
        this.disconnected = newGatewayGod.disconnected;
        this.staging = newGatewayGod.staging;
        this.beta = newGatewayGod.beta;
        this.debugMode = newGatewayGod.debugMode;
        this.enhancedLogging = newGatewayGod.enhancedLogging;
        this.zigbeeDisabled = newGatewayGod.zigbeeDisabled;
        this.doReboot = newGatewayGod.doReboot;
        this.doZigbeeReset = newGatewayGod.doZigbeeReset;
        this.getTrustedList = newGatewayGod.getTrustedList;
        this.installationCode = newGatewayGod.installationCode;
        this.version = newGatewayGod.version;
        this.updateSlot = newGatewayGod.updateSlot;
        this.locationName = newGatewayGod.locationName;
    }
}
exports.default = NewGatewayGod;
//# sourceMappingURL=new-gatewayGod.js.map